import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import * as types from 'modules/tireScan/actionTypes';
import type { ImportSource } from 'modules/tireScan/constants';
import type { FetchTireScansAction, FetchTireScansSuccessAction } from 'modules/tireScan/types';
import { createReducer, sourceMatcher } from 'utils/ReduxUtils';

export type TireScanImportIdsReducer = Array<string>;

const initialState: TireScanImportIdsReducer = [];

const beforeFetch = (state: TireScanImportIdsReducer, { payload }: FetchTireScansAction): TireScanImportIdsReducer => {
  const { lastRegistration, lastId, lastVin } = payload.request.params;
  const shouldReset = !lastRegistration && !lastId && !lastVin;

  if (shouldReset) {
    return [];
  }
  return state;
};

const onTireScanFetch = (
  state: TireScanImportIdsReducer,
  { payload }: FetchTireScansSuccessAction,
): TireScanImportIdsReducer => [...state, ...payload.content.map(({ id }) => id)];

const reset = (): TireScanImportIdsReducer => initialState;

const reducer = (source: ImportSource) =>
  createReducer<TireScanImportIdsReducer>(initialState, {
    [LOCATION_CHANGE]: reset,
    [types.FETCH_TIRE_SCAN_REQUEST]: sourceMatcher(source, beforeFetch),
    [types.FETCH_TIRE_SCAN_SUCCESS]: sourceMatcher(source, onTireScanFetch),
    [types.FETCH_TIRE_SCAN_FAILURE]: sourceMatcher(source, reset),
  });

export default reducer;
